export default __webpack_public_path__ + "static/media/14A.070.56737fdb.png";